import { Suspense, useEffect } from 'react';
/* eslint-disable import/no-unresolved */
import { Helmet } from 'react-helmet';
import { pdfjs } from 'react-pdf';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import 'react-pdf/dist/esm/Page/TextLayer.css';
/* eslint-enable import/no-unresolved */
import { Route, Routes, useLocation } from 'react-router-dom';

import { useBoundStore } from 'app/store';
import { FallbackWithLogo } from 'shared/ui';
import { useSaveServiceParams } from 'legacy/lib';

import { CaregiverFormPage } from './CaregiverForm/ui';
import { CompletePage } from './CompletePage/ui';
import { MainPage } from './Main/ui';
import { MobileFormPage } from './MobileForm/ui/MobileFormPage';
import { PdfFormPage } from './PdfForm/ui';
import { RedirectPage } from './RedirectPage/ui';
import { SubmittedFormPage } from './SubmittedForm/ui';
import { UserFormPage } from './UserForm/ui';
import './hsptlzForm.css';
// 개선된 코드
if (!pdfjs.GlobalWorkerOptions.workerSrc) {
  console.log('pdfjs.version', pdfjs.version);
  pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/legacy/build/pdf.worker.min.mjs`;
}

export const HsptlzForm = () => {
  const serviceParams = useBoundStore((state) => state['hsptlzForm'].serviceParams);
  const { ptNm } = useSaveServiceParams('hsptlzForm', serviceParams);
  const location = useLocation();

  useEffect(() => {
    if (window.history.scrollRestoration !== 'manual') window.history.scrollRestoration = 'manual';
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <>
      <Helmet>
        <meta name='viewport' />
      </Helmet>
      <Routes>
        <Route
          path='/'
          element={
            <Suspense>
              <MainPage />
            </Suspense>
          }
        />
        <Route
          path='/redirect'
          element={
            <Suspense
              fallback={
                <FallbackWithLogo
                  title={
                    <>
                      {ptNm}님의 입원 정보를 <br />
                      확인하고 있어요
                    </>
                  }
                  subTitle={'잠시만 기다려주세요.'}
                />
              }
            >
              <RedirectPage />
            </Suspense>
          }
        />
        <Route path='/user-form' element={<UserFormPage />} />
        <Route path='/submitted-form/:contentCode' element={<SubmittedFormPage />} />
        <Route path='/caregiver-form/:contentCode' element={<CaregiverFormPage />} />
        <Route path='/mobile-form/:contentCode' element={<MobileFormPage />} />
        <Route path='/pdf-form/:contentCode' element={<PdfFormPage />} />
        <Route
          path='/complete'
          element={
            <Suspense>
              <CompletePage />
            </Suspense>
          }
        />
      </Routes>
    </>
  );
};
